import React from 'react';
import './SearchForm.css';
import ToggleButtons from "./ToggleButtons";
import {SEARCH_TYPE_INVOICE, SEARCH_TYPE_ORDER} from './constants';

export default class SearchForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            formFields: {
                number: "",
                searchType: SEARCH_TYPE_INVOICE
            }
        };
    }

    handleFormChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        const {formFields} = this.state;

        if (target.type === 'checkbox') {
            const id = target.id;
            if (!formFields.hasOwnProperty(name)) {
                formFields[name] = {};
            }
            formFields[name][id] = value;
        } else {
            formFields[name] = value;
        }

        this.setState({formFields});
    };

    render() {
        const {onSearch} = this.props;
        const {formFields} = this.state;

        return (
            <div id="invoice-search-form">
                <p>Enter an Invoice# or Sales Order# below to copy the lines to this request</p>
                <div className="form-group">
                    <div className="text-center">
                        <ToggleButtons
                            name="searchType"
                            value={formFields.searchType}
                            onChange={(value) => {
                                // create a mock event object to play with the stock
                                // form change handler
                                const mockEventObject = {
                                    target: {
                                        type: "toggleButtons",
                                        value: value,
                                        name: "searchType"
                                    }
                                };
                                this.handleFormChange(mockEventObject);
                            }}
                            buttons={[
                                {value: SEARCH_TYPE_INVOICE, label: "Invoice#"},
                                {value: SEARCH_TYPE_ORDER, label: "Sales Order#"}
                            ]}/>
                    </div>
                </div>
                <div className="form-group">
                    <div className="row">
                        <div className="col-4 offset-4">
                            <input type="text"
                                   name="number"
                                   className="form-control"
                                   value={formFields.number}
                                   onChange={this.handleFormChange}
                            />
                        </div>
                    </div>
                </div>

                <div className="form-group text-center">
                    <button
                        onClick={() => {
                            onSearch(formFields.searchType, formFields.number)
                        }}
                        className="btn btn-secondary"
                    >Search
                    </button>
                </div>

            </div>
        );
    }
}